/**
 * VERDENSTORE v2.0 — Product Page
 * Variant picker, image gallery, zoom
 */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // ─── Image Gallery ───
  const mainImage = document.querySelector('[data-gallery-main]');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');

  if (mainImage && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.fullSrc;
        if (src) {
          mainImage.src = src;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }

  // ─── Variant Picker ───
  const variantForms = document.querySelectorAll('[data-variant-form]');
  variantForms.forEach(form => {
    const options = form.querySelectorAll('[data-variant-option]');
    const select = form.querySelector('select[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const stockEl = document.querySelector('[data-stock-indicator]');

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        if (opt.classList.contains('is-disabled')) return;

        const group = opt.dataset.optionGroup;
        form.querySelectorAll(`[data-option-group="${group}"]`).forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        opt.querySelector('input')?.setAttribute('checked', 'checked');

        // Update hidden select
        const variantId = opt.dataset.variantId;
        if (select && variantId) {
          select.value = variantId;
          // Trigger change for any listeners
          select.dispatchEvent(new Event('change'));
        }

        // Update price display
        if (priceEl && opt.dataset.price) {
          priceEl.textContent = opt.dataset.price;
        }
        if (compareEl) {
          if (opt.dataset.comparePrice) {
            compareEl.textContent = opt.dataset.comparePrice;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        // Update stock
        if (stockEl) {
          const qty = parseInt(opt.dataset.inventory || '0');
          const available = opt.dataset.available === 'true';
          if (!available) {
            stockEl.innerHTML = '<span class="stock-indicator__dot" style="background:var(--color-error)"></span> Chwilowo niedostępny';
          } else if (qty > 0 && qty <= 5) {
            stockEl.innerHTML = `<span class="stock-indicator__dot" style="background:var(--color-honey);animation:pulse 2s infinite"></span> Zostało tylko ${qty} szt.`;
          } else {
            stockEl.innerHTML = '<span class="stock-indicator__dot"></span> Dostępny — wysyłka w 24-48h';
          }
        }
      });
    });
  });

  // ─── Quantity Selector ───
  document.querySelectorAll('[data-quantity-selector]').forEach(container => {
    const input = container.querySelector('input');
    const minus = container.querySelector('[data-qty-minus]');
    const plus = container.querySelector('[data-qty-plus]');

    if (minus) minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    if (plus) plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  // ─── Accordion ───
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-accordion-item]');
      const isOpen = item.classList.contains('is-open');

      // Close siblings if needed
      const parent = item.closest('[data-accordion]');
      if (parent && parent.dataset.accordion === 'single') {
        parent.querySelectorAll('[data-accordion-item]').forEach(i => i.classList.remove('is-open'));
      }

      item.classList.toggle('is-open', !isOpen);
    });
  });
});
